<template>
    <be-alert icon-background :icon-text="`${roundedScore}%`" :color="color">
        <strong class="text-uppercase">{{ title }}</strong><br>
        {{ description }}
    </be-alert>
</template>

<script>
    export default {
        props: {
            score: Number,
            title: String,
            description: String,
        },

        computed: {
            color() {
                switch (true) {
                    case this.roundedScore >= 80:
                        return 'success';

                    case this.roundedScore >= 50:
                        return 'warning';

                    default:
                        return 'danger';
                }
            },

            roundedScore() {
                return Math.round(this.score);
            },
        },
    };
</script>
